import { HorizontalDivider, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';

import { StepIndex } from '../StepIndex';

import * as S from './style';

export function ReviewSection({
  stepIndex = 1,
  isCompleted = false,
  title,
  subTitle,
  titleHintText,
  headerChildren,
  children
}) {
  return (
    <S.ReviewSectionWrapper isCompleted={isCompleted}>
      <S.HeaderWrapper>
        <S.Col>
          <StepIndex stepIndex={stepIndex} isCompleted={isCompleted} />
          <S.TitleWrapper>
            <S.TitleCol>
              <Typography variant="subtitle1SemiBold" color="fg">
                {title}
              </Typography>
              {titleHintText}
            </S.TitleCol>
            <Typography variant="body1" color="fg" emphasis="weaker">
              {subTitle}
            </Typography>
          </S.TitleWrapper>
        </S.Col>
        <S.Col>{headerChildren}</S.Col>
      </S.HeaderWrapper>
      {children}
      <HorizontalDivider $margin="40px 0" />
    </S.ReviewSectionWrapper>
  );
}

ReviewSection.propTypes = {
  stepIndex: PropTypes.number,
  isCompleted: PropTypes.bool,
  title: PropTypes.string,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  headerChildren: PropTypes.node,
  children: PropTypes.node
};
